import React, { Component } from "react";
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts';
const numberWithCommas_display = require('../service/excelService.js').numberWithCommas_display;


class ExportPDF extends Component {


    constructor(props) {
        super(props);
        this.state = {
            dataSet: this.props.data,
            type: '',

            documentDefinition: {
                pageSize: 'A4',
                pageOrientation: 'portrait',
                content: [],
                dontBreakRows: true,
                pageMargins: [30, 50, 30, 50],
                startPosition: {
                    horizontalRatio: 0.2
                }
            }

        }

        // this.setState({ dataSet: this.props.data }, () => {
        //     this._exportPdfTable();
        // });

    }

    componentDidMount() {
        this._exportPdfTable();
    }

    componentWillUnmount() {
        this._exportPdfTable();
    }

    renderDesigRows(desigs) {
        var desigRows = []

        for (var i = 0; i < desigs.length; i++) {

            var desig = desigs[i];
            var row = []
            row.push({ text: desig['DesigID'], alignment: "left" })
            row.push({ text: desig['RcCode'], alignment: "left" })
            row.push({ text: desig['DesigName'], alignment: "left" })
            row.push({ text: '$' + numberWithCommas_display(desig['CreditCard']), alignment: "right" })

            desigRows.push(row)

        }

        return desigRows;

    }


    renderTotalRow(total) {

        var row = ['', ''];
        row.push({ text: 'Total:', alignment: "right", bold: true })
        row.push({ text: '$' + numberWithCommas_display(total), alignment: "right", bold: true })
        return row

    }

    renderColRow(columns) {

        var row = []

        for (var j = 0; j < columns.length; j++) {

            var col = columns[j].name;
            row.push({ text: col, alignment: "left" })

        }

        return row;
    }


    renderGroups(columns, groupList) {

        var rows = []
        var columnRow = this.renderColRow(columns);
        rows.push(columnRow);

        if (groupList && groupList.length && columns) {

            for (var i = 0; i < groupList.length; i++) {
                var group = groupList[i];

                var groupName = group.group;
                var groupNameRow = [
                    { text: groupName, alignment: "left", bold: true },
                    '', '', ''
                ]
                rows.push(groupNameRow);

                var desigs = group.desigs;
                var desigrows = this.renderDesigRows(desigs);
                var totalRow = this.renderTotalRow(group.credit_total);
                rows = rows.concat(desigrows);
                rows.push(totalRow);

            }
            return rows

        }

        return rows

    }

    renderGrandTotalRow = (total_data) => {

        var rows = [];

        for (var i = 0; i < total_data.length; i++) {

            var row = ['', '']
            var data = total_data[i];

            row.push({ text: data['colName'] + ':', alignment: "right", bold: true });
            row.push({ text: '$' + numberWithCommas_display(data['total']), alignment: "right", bold: true });

            rows.push(row)
        }

        return rows

    }

    renderEmptyRow = (columns) => {
        var row = [];
        for (var i = 0; i < columns.length; i++) {
            row.push('')
        }
        return row
    }

    _exportPdfTable = () => {
        const { dataSet } = this.state;
        // console.log('credit card report PDF',dataSet);

        const title = {
            text: dataSet.title,
            alignment: 'center',
            bold: true, fontSize: 16
        }

        const groupList = dataSet.data;
        const columns = dataSet.columns;
        const total_data = dataSet.total_data;

        var body = this.renderGroups(columns, groupList);
        var grandTotalRow = this.renderGrandTotalRow(total_data);

        body.push(this.renderEmptyRow(columns));
        body.push(this.renderEmptyRow(columns));

        body = body.concat(grandTotalRow);

        var income = {
            table: {
                //   widths:widths,
                //   heights:heights,
                headerRows: 1,
                //   dontBreakRows: true,
                body: body
            },
            layout: 'headerLineOnly'
        }

        var content = [title, income];
        // console.log('content', content)
        this.setState({ documentDefinition: { ...this.state.documentDefinition, content: content } });

    }


    onClick = () => {
        var documentDefinition = this.state.documentDefinition;
        const { vfs } = vfsFonts.pdfMake;
        pdfMake.vfs = vfs;
        return pdfMake.createPdf(documentDefinition).open();
    }

    render() {
        return (<button type="button" className='btn btn-primary' onClick={this.onClick.bind()}>Download PDF</button>)
    }

}


export default ExportPDF;
